module.exports = __webpack_public_path__ + "img/elementlengths.f3616243.png";